import http from 'common-module/src/util/http';

export async function globalSearch(data) {
  return http.post('/sys-search/total-station/new', data);
}

export async function getIssueId(id) {
  return http.post('/issue/get/by-subtask', { issueId: id });
}

export async function getIssueIdByLabel(id) {
  return http.post('/issue/get/by-label', { id: id });
}

// 加载历史搜索记录列表
export async function loadHistoryList() {
  return http.post('/sys-search/page-list/history', {});
}

// 清空历史记录列表
export async function clearHistory() {
  return http.post('/sys-search/clear/history');
}

/**
 * 查询最近访问事项
 * @param projectId       项目id，不传为跨项目查询
 * @param notInIssueIds 	需要排除的issue
*/
export const getRecentlyList = async (data = {}) => {
  return http.post('/issue/recently-issue-list', data);
};

/**
 * 推荐全站搜索
*/
export const globalSearchRecommend = async (data) => {
  return http.post('/sys-search/total-station/v2', data);
};

/**
 * 查询推荐
*/
export const getRecommendList = async () => {
  return http.post('/sys-search/list/recommend');
};

/**
 * 删除推荐
*/
export const deleteRecommendList = async (data) => {
  return http.post('/sys-search/delete/recommend', data);
};

/**
 * AI 搜索数据上报(用于算法组)
*/
export const reportGlobalSearch = async (data) => {
  return http.post(`/relationship/${data.userId}/global-search`, data, { showError: false });
};
